import "./App.css";
import TodoList from "./components/TodoList";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {TodosContext} from "./contexts/myContext";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

const theme = createTheme({
  typography: {
    fontFamily: "myFont",
  },
});

const inisialTodos = [
  {
    id: uuidv4(),
    title: "the first etape",
    details: "do what we need to do",
    isCompleted: false,
  },
  {
    id: uuidv4(),
    title: "the first etape",
    details: "do what we need to do",
    isCompleted: false,
  },
  {
    id: uuidv4(),
    title: "the first etape",
    details: "do what we need to do",
    isCompleted: false,
  },
];

function App() {
  const [todos, SetTodos] = useState(inisialTodos);
  return (
    <ThemeProvider theme={theme}>
      <div
        className="App"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#191b1f",
          direction: "ltr",
        }}
      >
        <TodosContext.Provider value={{ todos, SetTodos }}>
          <TodoList />
        </TodosContext.Provider>
      </div>
    </ThemeProvider>
  );
}

export default App;
